<template>
  <div class="task-draw" ref="task">
    <img src="../assets/title2-min.png" alt="title1" class="title" />
    <p class="describe">
      活动期间，每充值
      <span>50</span> 元，可获得
      <span>1</span> 次抽奖机会，每天最多获得
      <span>2</span> 次。
    </p>
    <div class="box">
      <img
        src="../assets/icon-btn.png"
        alt="btn"
        class="btn-prize"
        :style="record"
        @click.stop="openGoodsList"
      />
      <img src="../assets/icon2.png" alt="icon2" class="icon2" />
      <div class="draw-time">
        您还有
        <span>{{change}}</span> 次抽奖机会
      </div>
      <div class="draw-box">
        <ul class="list">
          <li
            :class="['item'+idx,{on:idx === current}]"
            v-for="(item,idx) in prizeList"
            :key="item.position"
          >
            <div class="bg"></div>
            <img :src="item.picture" :alt="item.prize" />
          </li>
        </ul>
        <div class="start" @click.stop="start" ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskDraw",
  props: {
    loginStatus: {
      type: Boolean,
      default: false
    },
    drawTimes:{
      type: [String,Number],
      default: 0
    }
  },
  data: () => ({
    record: {
      position: "fixed",
      cursor: "pointer",
      width: "1rem",
      top: "10rem",
      right: "0",
      zIndex: 12
    },
    showRecord: true,
    title: "",
    prizeList: [],
    speed: 60,
    diff: 1000,
    award: null,
    time: 0,
    current: -1,
    ok: true,
    change:0
  }),
  watch:{
    drawTimes:function(val){
      this.change=val;
    }
  },
  created() {
    this.$api.activity.prizeList().then(res => {
      if (res.data.code === 0) {
        let { data } = res.data;
        this.prizeList = data;
      }
    });
  },
  mounted() {
    this.record.right =
      Math.floor(this.$refs.task.getBoundingClientRect().right) -
      Math.floor(this.$refs.task.getBoundingClientRect().width) +
      10 +
      "px";
    let that=this;
    let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    let recalc=function(){
      
      that.record.right=Math.floor(that.$refs.task.getBoundingClientRect().right) -
      Math.floor(that.$refs.task.getBoundingClientRect().width) +
      10 +
      "px"
    }
    window.addEventListener(resizeEvt,recalc, false)
  },
  methods: {
    //判断是否登录
    isLogin() {
      return this.loginStatus ? true : false;
    },
    //打开中奖记录列表
    openGoodsList() {
      if (!this.isLogin()) {
        this.$toast({
          message: "请登录",
          duration: 1200,
          position: "bottom"
        });
        this.$parent.open("login");
        return;
      } else {
        this.$parent.open("prizeList");
      }
    },
    //抽奖结束的逻辑
    endDraw() {
      this.ok = !this.ok;
      this.$emit("get-prize", this.award);
      this.award.position = 0;
      this.speed = 60;
    },
    start() {
      if (!this.isLogin()) {
        this.$toast({
          message: "请登录",
          duration: 1200,
          position: "bottom"
        });
        this.$parent.open("login");
        return;
      }
      if (!this.ok) return;
      this.ok = !this.ok;
      // 开始抽奖
      this.drawAward();
      this.time = Date.now();
    },
    drawAward() {
      this.$api.activity.clickDraw().then(res => {
        if (res.data.code === 0) {
          let { data } = res.data;
          this.award = data;
          this.change=data.drawTimes;
          this.move();
        } else {
          this.$toast({
            message: res.data.msg,
            duration: 1200,
            position: "middle"
          });
          this.ok = !this.ok;
        }
      });
    },
    move() {
      this.timeout = setInterval(() => {
        this.current++;
        if (this.current > 11) {
          this.current = 0;
        }
        if (
          this.award.position ||
          (this.award.position == 0 && (Date.now() - this.time) / 400 > 2)
        ) {
          this.speed += this.diff;
          if (
            (Date.now() - this.time) / 400 > 4 &&
            this.award.position == this.prizeList[this.current].position
          ) {
            clearTimeout(this.timeout);
            //抽奖结束的时候触发
            setTimeout(this.endDraw, 400);
            return;
          }
        } else {
          this.speed -= this.diff;
        }
      }, this.speed);
    }
  }
};
</script>

<style lang="scss" scoped>
.task-draw {
  margin-bottom: 110px;
}
.title {
  display: block;
  width: 880px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.describe {
  font-size: 24px;
  padding: 0 130px;
  color: rgba(110, 53, 33, 1);
  text-align: center;
  line-height: 50px;
  margin-bottom: 130px;
  span {
    font-size: 30px;
    color: #ec370c;
    font-weight: 600;
  }
}
.box {
  margin: 0 auto;
  width: 980px;
  height: 1000px;
  background-color: #fff;
  border-radius: 50px;
  padding: 10px;
  position: relative;
  .draw-box {
    width: 100%;
    height: 100%;
    padding: 60px 50px;
    box-sizing: border-box;
    background: rgba(255, 253, 251, 1);
    box-shadow: inset 0px 0px 20px 0px rgba(244, 160, 68, 0.78);
    border-radius: 50px;
    position: relative;
    .list {
      width: 100%;
      height: 100%;
      position: relative;
      li {
        position: absolute;
        width: 205px;
        height: 205px;
        background: rgba(255, 255, 255, 1);
        box-shadow: inset 0px 0px 50px 0px rgba(247, 165, 89, 0.5);
        border-radius: 30px;
        .bg {
          background: rgba(248, 231, 219, 1);
          box-shadow: inset 0px 0px 50px 0px rgba(255, 218, 18, 0.8);
          border-radius: 30px;
          position: absolute;
          width: 100%;
          height: 100%;
          display: none;
        }
        img {
          display: block;
          position: absolute;
          top:0;
          left:0;
          width: 100%;
          height: 100%;
        }
      }
      .item0 {
        top: 0;
        left: 0;
      }
      .item1 {
        top: 0;
        left: 225px;
      }
      .item2 {
        top: 0;
        right: 225px;
      }
      .item3 {
        top: 0;
        right: 0;
      }
      .item4 {
        top: 225px;
        right: 0;
      }
      .item5 {
        bottom: 225px;
        right: 0;
      }
      .item6 {
        bottom: 0;
        right: 0;
      }
      .item7 {
        bottom: 0;
        right: 225px;
      }
      .item8 {
        bottom: 0;
        left: 225px;
      }
      .item9 {
        bottom: 0;
        left: 0;
      }
      .item10 {
        bottom: 225px;
        left: 0;
      }
      .item11 {
        top: 225px;
        left: 0;
      }
      .on {
        .bg {
          display: block;
        }
      }
    }
    .start {
      background-image: url('../assets/btn-draw.png');
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 418px;
      height: 418px;
      cursor: pointer;
    }
  }
  .icon1 {
    position: absolute;
    left: 0;
    top: -105px;
    width: 145px;
    height: 154px;
    z-index: 9;
  }
  .icon2 {
    position: absolute;
    left: -45px;
    bottom: -30px;
    width: 117px;
    height: 115px;
    z-index: 9;
  }
  .draw-time {
    position: absolute;
    left: 50%;
    top: -80px;
    transform: translateX(-50%);
    padding: 0 40px;
    height: 80px;
    background: #ffffff;
    border-radius: 31px 31px 0px 0px;
    font-size: 26px;
    text-align: center;
    line-height: 80px;
    color: #9c6429;
    span {
      font-size: 34px;
      font-weight: 600;
      color: #ff6d5d;
    }
  }
}
</style>